/*
 * ONLINE_NOW_V1: what the header's "Active now" says this person is looking at.
 * A record page names itself (e.g. "Jane Smith · Notes"); every other page is named from its
 * path (the sidebar item it's under).
 */

let recordPlace = null;
const listeners = new Set();

/** A record page names itself while it's open (null when it closes) */
export const setRecordPlace = label => {
  if (recordPlace === label) return;
  recordPlace = label;
  listeners.forEach(fn => fn(label));
};

export const getRecordPlace = () => recordPlace;

export const onRecordPlace = fn => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const PAGES = {
  '': 'Dashboard',
  v2: 'Dashboard',
  settings: 'Admin Settings',
  account: 'Account',
  help: 'Help',
  merges: 'Merges'
};

const titleCase = text =>
  text
    .split(/[-_]/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

/** A page's name from its path, using the sidebar's names where there is one */
export const pageName = (pathname, sidebarItems = []) => {
  const [first = '', second] = pathname.split('/').filter(Boolean);
  const item = sidebarItems.find(i => i.path === `/${first}`);
  const name = item ? item.name : PAGES[first] ?? titleCase(first);
  // A record that hasn't named itself yet: say which one, so it never reads as the list page
  // (a pipeline's id is the board, not a record)
  const record = first !== 'pipelines' && second && /^(\d+|[0-9a-f-]{36})$/i.test(second);
  return record ? `${name} · ${second}` : name;
};
